import { CancellationReasonMaster, ConsentType } from "../../services/types";
import { getCancellationReasons } from "./master.action";

export interface ContextValue {
    state: State;
    dispatch: (callback: (state: State) => void) => void;
}

export interface State {
    loading: boolean;
    cancellationReason: CancellationReasonMaster[];
    type?: ConsentType;
}

export interface Action {
    getCancellationReasons: ReturnType<typeof getCancellationReasons>
}

export enum ActionType {
    GET_CANCELLATION_REASON_SUCCESS = 'GET_CANCELLATION_REASON_SUCCESS'
}

export type ActionPayload =
    | { type: ActionType.GET_CANCELLATION_REASON_SUCCESS; payload: { cancellationReason: CancellationReasonMaster[], type: ConsentType } }
